<template>
  <div class="d-flex flex-row flex-nowrap align-center py-1" :key="user._id">
    <v-checkbox v-if="multiple" :input-value="isSelected" class="mr-2" hide-details dense @change="toggle" />
    <div class="image-wrapper mr-2">
      <img :src="avatar" alt="" />
    </div>
    <div class="name-text">{{ user.name }}</div>
  </div>
</template>
<script>
import get from 'lodash-es/get'
export default {
  props: {
    user: Object,
    isSelected: Boolean,
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    avatar() {
      return get(this.user, 'avatar.url', require('@/assets/default-avatar.svg'))
    },
  },
  methods: {
    toggle() {
      this.$emit('onToggleUser', this.user)
    },
  },
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  width: 45px;
  min-width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
}
.name-width {
  width: 200px;
}
.name-text {
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-width {
  width: 100px;
}
.item-text {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
